import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Doughnut } from 'react-chartjs-2'

// styles
import colors from '../../../styles/colors'

const TEMP_COLOR = ['#6bd1f1', '#0088ff', '#a8a8a8', '#9b429d', '#ff8e1d']

const LABEL_COLOR = [colors.D1, colors.D2, colors.D3, colors.D4, colors.D5, ,]

const NewMenuChart = ({ isMobile, chartItem }) => {
  const chartRef = useRef(null)
  const [pieData, setPieData] = useState({
    labels: [
      '초코나무 숲',
      '우리엄마는 외계인',
      '민트초코',
      '샤베트',
      '베리베리스트로베리',
    ],
    datasets: [
      {
        label: '총 판매량',
        fill: false,
        lineTension: 0.1,
        backgroundColor: TEMP_COLOR,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(71, 225, 167, 0.5)',
        pointHoverBorderColor: 'rgb(71, 225, 167)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: Array.from(
          { length: 5 },
          (v, i) => (v = Math.floor(Math.random() * (100 - 1) + 1)),
        ),
      },
    ],
  })
  const [data, setData] = useState({
    labels: null,
    datasets: [
      {
        label: '총 판매량',
        fill: false,
        lineTension: 0.1,
        backgroundColor: TEMP_COLOR,
        borderJoinStyle: 'miter',
        pointBorderColor: 'rgba(75,192,192,1)',
        pointBackgroundColor: '#fff',
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: 'rgba(71, 225, 167, 0.5)',
        pointHoverBorderColor: 'rgb(71, 225, 167)',
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: null,
      },
    ],
  })
  const [options, setOptions] = useState(null)

  // 중앙 텍스트
  const textCenter = {
    id: 'textCenter',
    beforeDatasetsDraw(chart, args, pluginOptions) {
      const { ctx, data } = chart

      let sum = 0
      if (data?.datasets[0]?.data) {
        sum = data?.datasets[0]?.data.reduce((a, b) => a + b, 0)
      }

      ctx.save()
      ctx.font = 'bolder 14px sans-serif'
      ctx.fillStyle = colors.BK
      ctx.textAlign = 'center'
      // ctx.textBaseLine = 'middle'
      ctx.fillText(
        '총판매량',
        chart.getDatasetMeta(0).data[0].x,
        chart.getDatasetMeta(0).data[0].y - 10,
      )

      ctx.font = 'bolder 20px sans-serif'
      ctx.fillStyle = colors.mainG
      ctx.textAlign = 'center'
      ctx.textBaseLine = 'middle'
      ctx.fillText(
        `${sum}개`,
        chart.getDatasetMeta(0).data[0].x,
        chart.getDatasetMeta(0).data[0].y + 18,
      )
    },
  }

  // 툴팁 그림자
  const shadowPlugin = {
    id: 'shadow',
    beforeDraw: (chart) => {
      const { ctx } = chart
      const _fill = ctx.fill

      ctx.fill = function () {
        ctx.save()
        ctx.shadowColor = 'rgba(0, 0, 0, 0.1)'
        ctx.shadowBlur = 12
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 3
        _fill.apply(this, arguments)
        ctx.restore()
      }
    },
  }

  // 플러그인
  const plugins = [textCenter, shadowPlugin]

  useEffect(() => {
    if (chartItem) {
      setData({
        ...data,

        labels: chartItem.menu,
        datasets: [
          {
            label: '차트뷰',
            borderColor: TEMP_COLOR,
            borderWidth: 2,
            data: chartItem.count,
            fill: false,
            backgroundColor: TEMP_COLOR,
            pointHoverRadius: 2,
            pointHoverBorderWidth: 4,
          },
        ],
      })

      setOptions({
        responsive: true,
        cutout: '70%',

        maintainAspectRatio: false,

        elements: {
          arc: {
            borderWidth: 0,
          },
        },

        scales: {
          x: {
            grid: {
              display: false,
            },
            ticks: {
              display: false,
            },
            border: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
              color: 'blue',
            },
            ticks: {
              display: false,
            },
            border: {
              display: false,
            },
          },
        },
        plugins: {
          legend: {
            position: isMobile ? 'bottom' : 'right',
            labels: {
              usePointStyle: true,
              padding: 16.5,
              font: {
                size: 10,
              },

              generateLabels: function (chart) {
                return ''
              },
            },
          },
          title: {
            display: false,
            text: '도넛',
          },

          tooltip: {
            backgroundColor: 'white',
            padding: 12,

            xAlign: 'left',
            yAlign: 'center',

            titleColor: 'black',
            bodyColor: colors.mainG,
            caretSize: 0,

            titleMarginBottom: 8,

            titleFont: {
              size: 12,
              weight: 400,
            },
            bodyFont: {
              size: 10,
            },
            bodyAlign: 'left',
            footerFont: {},

            usePointStyle: true,

            callbacks: {
              labelColor: function (item) {
                return {
                  borderColor: 'green',
                  backgroundColor: 'green',
                }
              },
              labelPointStyle: function (context) {
                return {
                  pointStyle: 'circle',
                  rotation: 0,
                }
              },
              label: function (item) {
                return ` ${item.formattedValue}개`
              },
            },
          },
        },
      })
    }
  }, [chartItem])

  return (
    <Container>
      {data && options && (
        <>
          <ChartWrapper>
            <Doughnut
              data={data}
              options={options}
              plugins={plugins}
              ref={chartRef}
            />
          </ChartWrapper>
          <DivideLine />
          <LabelWrapper>
            {chartItem.menu.map((item, idx) => (
              <LabelItem key={idx} bgColor={LABEL_COLOR[idx]}>
                <span />
                <span>{item}</span>
              </LabelItem>
            ))}
            {/* {LABEL_COLOR.map((item, idx) => (
              <LabelItem key={idx} bgColor={item.color}>
                <span />
                <span>{item.name}</span>
              </LabelItem>
            ))} */}
          </LabelWrapper>
        </>
      )}
    </Container>
  )
}

export default NewMenuChart

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  @media ${(props) => props.theme.mobile} {
    flex-direction: column;
  }
`

const ChartWrapper = styled.div`
  width: 50%;

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    height: 55%;
  }
`

const DivideLine = styled.div`
  width: 1px;
  height: 100%;
  background-color: ${colors.W4};

  @media ${(props) => props.theme.mobile} {
    display: none;
  }
`

const LabelWrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding-left: 30px;
  justify-content: space-between;

  @media ${(props) => props.theme.mobile} {
    width: 100%;
    height: 45%;
    padding-left: 0px;
    padding-top: 18px;
  }
`

const LabelItem = styled.div`
  display: flex;

  span:nth-child(1) {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: ${(props) => `${props.bgColor}`};
    margin-right: 4px;
  }

  span:nth-child(2) {
    font-size: 12px;
    color: ${colors.G4};
  }
`
